export interface ITranslationsTable {
  [key: string]: string;
  orderAsc: string;
  orderDes: string;
  compressData: string;
  extendData: string;
  filter: string;
  hideColumn: string;
}
export interface ILanguageTable {
  language: string;
  translations: ITranslationsTable;
}
export const translations: ILanguageTable[] = [
  {
    language: "es",
    translations: {
      orderAsc: "Ordenar columna ascendente",
      orderDes: "Ordenar columna descendente",
      compressData: "Comprimir datos",
      extendData: "Expandir datos",
      filter: "Filtrar",
      hideColumn: "Ocultar Columna",
    },
  },
  {
    language: "en",
    translations: {
      orderAsc: "Sort ascending column",
      orderDes: "Sort descending column",
      compressData: "Compress data",
      extendData: "Expand data",
      filter: "Filter",
      hideColumn: "Hide column",
    },
  },
];
